import React from "react";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { PopoverCell, Popover } from "./PopoverCell";

interface Props {
  cropfields?: number[];
  index?: number[];
  value: any;
}
export const CropfieldLinkCell = ({ cropfields, index, value }: Props) => {
  if (!(cropfields && index)) return <span>{value}</span>;
  return (
    <PopoverCell value={value}>
      {(props) => (
        <Popover id="cfpopover" {...props} className="inline-record-edit-popover">
          <Popover.Title>{gettext("Cropfields")}</Popover.Title>
          <Popover.Content className="overflow-auto">
            <table className="inline-record-edit-overlay table table-striped">
              <thead>
                <tr>
                  <th colSpan={2}>{gettext("Cropfield")}</th>
                </tr>
              </thead>
              <tbody>
                {cropfields.map((c, i) => {
                  const cropfield = cropr.cropfields.get(c);
                  if (!cropfield) return null;
                  return (
                    <tr key={c}>
                      <td>
                        <a href={`#financial/1/${index[i]}/`}>{cropfield.get("name")}</a>
                      </td>
                      <td>{cropfield.getAreaString()}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Popover.Content>
        </Popover>
      )}
    </PopoverCell>
  );
};
